/** Rotas cujo URL carrega segredo (convite): Session Replay não pode gravar (o evento Meta do rrweb guarda location.href). */
export function shouldRecordReplay(pathname: string): boolean {
  return !pathname.startsWith('/pre-cadastro');
}
